<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="show" :data="model" scrollable
                   :title="computedTitle" @show="onShow"
                   @hidden="onHidden" @ok.prevent="onSubmit" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading">
      <div class="row">
        <div class="col-md-12">
          <language-code-select-input-widget :model="model" attribute="language_code"/>
        </div>
        <div class="col-md-12">
          <input-widget type="checkbox" attribute="include_field_with_html_tags" :model="model"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import SaleExportModel from "@/modules/sales/view/modals/SaleExport.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import LanguageCodeSelectInputWidget from "@/core/widgets/LanguageCodeSelectInputWidget";
  import {cloneDeep} from "lodash";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  export default {
    name: "SaleExportModal",
    components: {
      LanguageCodeSelectInputWidget,
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new SaleExportModel(),
      }
    },
    computed: {
      ...mapState({
        show: state => state.saleExportModal.show,
        sale: state => state.saleExportModal.sale,
        fileType: state => state.saleExportModal.fileType,
      }),
      computedTitle() {
        return this.sale ? this.$i18n.t('Export Excel File for {sale_no}', {
          sale_no: this.sale.sale_no
        }) : ''
      }
    },
    methods: {
      ...mapActions(['hideSaleExportModal']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new SaleExportModel();
        this.hideSaleExportModal();
      },
      async onSubmit() {
        this.showConfirmation = false
        this.$emit('onSubmit', {
          include_field_with_html_tags: !!this.model.include_field_with_html_tags,
          language_code: this.model.language_code,
          file_type: this.fileType,
          sale: cloneDeep(this.sale)
        })
        this.hideSaleExportModal()
      },
    }
  }
</script>

<style scoped>

</style>
